import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const AllDeployedTransactionContainerData = async (StartDate, endDatae) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `RawReport/GetAllDeployedContainersTransaction?startDate=${StartDate}&endDate=${endDatae}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};